import { Inertia } from '@inertiajs/inertia'
import { Component, h, Host, Prop, Watch } from '@stencil/core'
import Axios from 'axios'
import { IUser } from 'src/page/admin/types'

import { ProgressLine } from '../../../onboarding/ui'
import { AppType, IBrowserPlatform } from '../../../ui/download/download'

@Component({
  tag: 'page-onboarding-desktop-app',
  assetsDirs: ['assets'],
})
export class PageOnboardingDesktopApp {
  @Prop() appDownloadUrls: Record<AppType, string>
  @Prop() downloadedAppUrl?: string
  @Prop() nextStepUrl?: string
  @Prop() skippedDownloadUrl?: string
  @Prop() clickedDownloadUrl?: string
  @Prop({ mutable: true }) isBonus = false
  @Prop() isZoomAppConnected: boolean
  @Prop() overridePlatform?: IBrowserPlatform

  @Prop() currentUser?: IUser
  @Prop() logoutUrl?: string

  @Prop() browserPlatform: IBrowserPlatform
  @Prop() signupProgressPercent: number

  @Prop() pusherClient: typeof Pusher
  @Prop() pusherConfig: { channel: string; event: string }

  @Watch('pusherClient')
  @Watch('pusherConfig')
  initPusher() {
    if (this.pusherClient && this.pusherConfig) {
      const channel = this.pusherClient.subscribe(this.pusherConfig.channel)
      channel.bind(this.pusherConfig.event, () => {
        // Waiting just a smidge since this is likely a background tab anyway
        // and we need the actual sign-in tab to clear the deep link
        setTimeout(() => Inertia.visit(this.nextStepUrl), 1000)
      })
    }
  }

  componentWillLoad() {
    this.isBonus ||= !!this.skippedDownloadUrl
  }

  componentDidLoad() {
    this.initPusher()
  }

  get canSkip() {
    return this.isBonus
  }

  async skip() {
    await Axios.post(this.skippedDownloadUrl)
    Inertia.visit(this.nextStepUrl)
  }

  render() {
    return (
      <Host class='flex overflow-auto flex-col items-center w-full h-screen text-base'>
        <ProgressLine percent={this.signupProgressPercent} />
        <div class='flex absolute top-10 right-0 left-0 justify-center'>
          <ui-logo size='xl' />
        </div>

        <div class='flex flex-col flex-grow justify-center items-center py-15'>
          <h4 class='font-medium leading-xl text-glyph-lighter uppercase'>
            <span class='font-bold'>Last Step:</span> Install Desktop App
          </h4>
          <h1 class='mt-1 mb-5 text-3xl font-bold text-center text-glyph-base spacing-y-2'>
            {this.isZoomAppConnected ? (
              <div class='max-w-lg'>Install Fathom to get amazing notes on any platform!</div>
            ) : (
              <div class='max-w-lg'>Install Fathom to get amazing notes on your next meeting!</div>
            )}
          </h1>

          <ui-download
            appDownloadUrls={this.appDownloadUrls}
            downloadedAppUrl={this.downloadedAppUrl}
            browserPlatform={this.overridePlatform || this.browserPlatform}
            autoProgressUrl={this.clickedDownloadUrl}
          />

          {this.canSkip && !!this.skippedDownloadUrl && (
            <button class='mt-8 text-glyph-lighter hover:text-link underline' onClick={async () => await this.skip()}>
              Skip and download later
            </button>
          )}
        </div>
        {this.logoutUrl && this.currentUser ? (
          <sign-out-bar class='mb-2' user={this.currentUser} logoutUrl={this.logoutUrl}></sign-out-bar>
        ) : null}
      </Host>
    )
  }
}
